@if (showToggle) {
<div class="top-hr-wrapper" (click)="onToggleHeight()">
  <!-- <hr class="top-hr" style="cursor: pointer;"> -->
  @if (isDesktop()) {
    <img class="icon arrow icon-gray-300" [class.flipped]="isFullyOpen()" src="assets/icons/modal-arrow.svg" alt="close">
  } @else {
    <img class="icon arrow icon-gray-300" [class.flipped]="isFullyOpen()" src="assets/icons/modal-arrow.svg" alt="open">
  }
</div>
}

<div class="top-bar header" [style.background-color]="bgColor"
  [style.max-height.px]="maxHeight !== 0 ? maxHeight : null">
  <h3 class="point-name h3-bold notranslate" translate="no" (click)="onToggleHeight()">
    {{ title }}
  </h3>
  @if (showClose) {
  <div class="back-button ion-no-padding" fill="clear" (click)="onClose()">
    <img src="assets/icons/cruz.svg" name="close-outline" class='close-icon icon-24 icon-text-primary' />
  </div>
  }
</div>  